import { render, staticRenderFns } from "./m-create-new-user.vue?vue&type=template&id=1f645f28&scoped=true&"
import script from "./m-create-new-user.ts?vue&type=script&lang=ts&"
export * from "./m-create-new-user.ts?vue&type=script&lang=ts&"
import style0 from "./m-create-new-user.scss?vue&type=style&index=0&id=1f645f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f645f28",
  null
  
)

export default component.exports